<template>
  <div class="wrap">
    <div class="left" @click="goBack"><i class="iconfont icon-fanhui"></i></div>
    <ul class="right">
        <li class="language_s" @click="changeLan($event, 'zh')"><a href="javascript:;">简</a></li>
        <li class="language_s" @click="changeLan($event, 'en')"><a href="javascript:;">EN</a></li>
        <li class="language_s" @click="changeLan($event, 'hk')"><a href="javascript:;">繁</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  data () {
    return {}
  },
  methods: {
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1) : this.$router.push('/')
    },
    changeLan (event, lan) {
      // this.$root.i18n.locale = lan
      console.log(this.$i18n.locale)
      if (this.$i18n.locale === lan) {
        return false
      } else {
        this.$i18n.locale = lan
        localStorage.setItem('lan', lan)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .wrap
    height 34px
    display flex
    justify-content space-between
    background url('../assets/img/is_background.jpg') 0px 836px
    font-size: 14px
    color #ffffff
    position fixed
    z-index 99
    width 100%
    border-bottom 1px solid #ffffff
    .left
      line-height 34px
      width 21px
      margin-left 10px
    .right
      line-height 34px
      width 106px
      margin-right 10px
      display flex
      justify-content space-around
    ul
      display flex
      justify-content flex-end
      align-items center
      height 34px
      margin-bottom 0px
      li
        list-style none
        margin 0 10px
        a
          color #ffffff
          &:hover
            color #ffffff
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue